import {
	connect
} from 'react-redux'
import PackingBySystemComponent from '../components/PackingBySystemComponent.jsx';
import {
	findAllFirefighterTypes,
	findDistinctCategories,
	changePackingBySystemBeanValue,
	changeShippingLabelValue,
	packingItems,
	closePackingBoxNumberModal,
	findShippingLabel,
	editShippingBoxLabel,
	clearPackingItems,
	clearAllPackingItems,
	findPackingItemList,
	clearPackingAlert
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['packingReducer', 'orderId']),
	packingBySystemBean: state.getIn(['packingReducer', 'packingBySystemBean']),
	packingBySystemValidation: state.getIn(['packingReducer', 'packingBySystemValidation']),
	allFirefighterTypes: state.getIn(['commonReducer', 'allFirefighterTypes']),
	distinctCategories: state.getIn(['packingReducer', 'distinctCategories']),
	packTypes: [{ label: '一個人一箱', value: 1 }, { label: '五套一箱', value: 2 }, { label: '十件一箱', value: 3 }],
	alertStyle: state.getIn(['packingReducer', 'alertStyle']),
	alertMessage: state.getIn(['packingReducer', 'alertMessage']),
	showPackingBoxNumberModal: state.getIn(['packingReducer', 'showPackingBoxNumberModal']),
	boxNumbers: state.getIn(['packingReducer', 'boxNumbers']),
	shippingLabel: state.getIn(['packingReducer', 'shippingLabel']),
	shippingLabelValidation: state.getIn(['packingReducer', 'shippingLabelValidation']),

	activePage: state.getIn(['packingItemListReducer', 'activePage']),
	itemPerPage: state.getIn(['packingItemListReducer', 'itemPerPage'])
})

const mapDispatchToProps = (dispatch) => ({
	findAllFirefighterTypes: () => {
		dispatch(findAllFirefighterTypes());
	},
	findDistinctCategories: () => {
		dispatch(findDistinctCategories());
	},
	findShippingLabel: (payload) => {
		dispatch(findShippingLabel(payload));
	},
	setPackingBySystemBeanValue: (id, value) => {
		dispatch(changePackingBySystemBeanValue({
			id: id,
			value: value
		}))
	},
	setShippingLabelValue: (id, value) => {
		dispatch(changeShippingLabelValue({
			id: id,
			value: value
		}))
	},
	packingItems: (packingBySystemBean, pagingData) => {
		dispatch(packingItems(packingBySystemBean, pagingData));
	},
	editShippingBoxLabel: (shippingLabel) => {
		dispatch(editShippingBoxLabel(shippingLabel));
	},
	clearPackingItems: (shippingLabel, pagingData) => {
		let r = confirm('確認刪除 箱號: ' + shippingLabel.get('boxNumber') + '?');
		if (r === true) {
			dispatch(clearPackingItems(shippingLabel, pagingData));
		}
	},
	clearAllPackingItems: (shippingLabel, pagingData) => {
		let r = confirm('確認刪除 ?');
		if (r === true) {
			dispatch(clearAllPackingItems(shippingLabel, pagingData));
		}
	},
	closeModal: () => {
		dispatch(closePackingBoxNumberModal());
	},
	findPackingItemList: (payload) => {
		dispatch(findPackingItemList(payload, { activePage: 1, itemPerPage: 10 }));
	},
	clearPackingAlert: () => {
		dispatch(clearPackingAlert());
	},

})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	orderId: stateProps.orderId,
	packingBySystemBean: stateProps.packingBySystemBean,
	packingBySystemValidation: stateProps.packingBySystemValidation,
	allFirefighterTypes: stateProps.allFirefighterTypes,
	distinctCategories: stateProps.distinctCategories,
	packTypes: stateProps.packTypes,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	showPackingBoxNumberModal: stateProps.showPackingBoxNumberModal,
	boxNumbers: stateProps.boxNumbers,
	activePage: stateProps.activePage,
	itemPerPage: stateProps.itemPerPage,
	shippingLabel: stateProps.shippingLabel,
	shippingLabelValidation: stateProps.shippingLabelValidation,

	findAllFirefighterTypes: dispatchProps.findAllFirefighterTypes,
	findDistinctCategories: dispatchProps.findDistinctCategories,
	findShippingLabel: dispatchProps.findShippingLabel,
	setPackingBySystemBeanValue: dispatchProps.setPackingBySystemBeanValue,
	setShippingLabelValue: dispatchProps.setShippingLabelValue,
	packingItems: () => dispatchProps.packingItems(stateProps.packingBySystemBean, {
		activePage: stateProps.activePage,
		itemPerPage: stateProps.itemPerPage
	}),
	editShippingBoxLabel: () => dispatchProps.editShippingBoxLabel(stateProps.shippingLabel),
	clearPackingItems: () => dispatchProps.clearPackingItems(stateProps.shippingLabel, {
		activePage: stateProps.activePage,
		itemPerPage: stateProps.itemPerPage
	}),
	clearAllPackingItems: () => dispatchProps.clearAllPackingItems(stateProps.shippingLabel, {
		activePage: stateProps.activePage,
		itemPerPage: stateProps.itemPerPage
	}),
	closeModal: dispatchProps.closeModal,
	findPackingItemList: dispatchProps.findPackingItemList,
	clearPackingAlert: dispatchProps.clearPackingAlert,
})

const PackingBySystemContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(PackingBySystemComponent)

export default PackingBySystemContainer;


// WEBPACK FOOTER //
// ./src/containers/PackingBySystemContainer.jsx